<template>
  <div class="Name"><img :src="imgSrc" :alt="name"/><a :href="href" target="_blank">{{name}}</a>
  </div>
</template>

<script>
  export default {
    name: 'Name',
    props: {
      name: String,
      logo: String,
      href: {
        type: String,
        default: '#',
      },
      subNode: Array,
    },
    data() {
      return {
        down: false,
      };
    },
    methods: {
      show() {
        if (this.down) {
          document.getElementById('button').innerHTML = '&#x25B3';
        } else {
          document.getElementById('button').innerHTML = '&#9660';
        }
        this.down = !this.down;
      },
    },
    computed: {
      imgSrc() {
        return `${this.logo}`;
      },
    },
  };
</script>

<style scoped lang="scss">
  .Name {
    display: flex;
    align-items: center;
    img {
      vertical-align: middle;
      width: 25px;
      height: 25px;
    }
    a {
      vertical-align: middle;
      margin-left: 10px;
      // font-weight: bold;
    }
    button {
      outline: none;
      background: transparent;
      margin-left: 10px;
      border: None;
    }
  }
</style>
